import { Select } from 'antd';
import { useMemo } from 'react';

import AngleDown from '../../../assets/AngleDown';
import styles from './AppSelectPill.module.scss';

const AppSelectPill = ({
  options = [],
  value,
  onChange,
  placeholder = 'Select an option',
  loading = false,
  disabled = false,
  className = '',
  popupClassName = '',
  ...props
}) => {
  // const popupRender = (menu) => {
  //   console.log('menu', menu);

  //   return (
  //     <div className={styles.popupContent}>
  //       {menu}
  //     </div>
  //   );
  // };

  const selectOptions = useMemo(() => {
    return options.map((option, index) => ({
      value: option.value,
      label: (
        <div>
          {option.icon && <span>{option.icon}</span>}
          <span className={styles.optionText}>{option.label}</span>
        </div>
      ),
      className: index > 0 ? styles.withDivider : '',
      ...option,
    }));
  }, [options]);

  return (
    <Select
      value={value}
      onChange={onChange}
      options={selectOptions}
      placeholder={placeholder}
      loading={loading}
      disabled={disabled}
      // popupRender={popupRender}
      className={`${styles.appSelectPill} ${className}`}
      // rootClassName={}
      classNames={{
        popup: {
          root: `${styles.popupContent} ${popupClassName}`,
        },
      }}
      suffixIcon={<AngleDown />}
      {...props}
    />
  );
};

export default AppSelectPill;
